<template>
  <div class="col-md-8 pdf-doc">
    <div class="btn-toolbar">
      <div class="btn-group">
        <!--<a title="Extract" class="btn btn-inverse" v-bind:class="{selected: isChecked}" @click="setExtraction"><font-awesome-icon icon="crop" class="icon"/></a>-->
      </div>
    </div>

    <iframe :src="viewer" class="iframe" id="pdf-id" ref="pdfFrame"></iframe>

    <entire-page-extraction
      v-if="showModal"
      v-on:extractCurrentPage="extractCurrentPage"
      v-on:extractPages="extractPages"
      @close="showModal = false"
    ></entire-page-extraction>
  </div>
</template>
<script>
import EventBus from "../../../event-bus";
import { getGrabbedImage, getGrabbedPage } from "@/api/pdfApi";
import {
  CurrentPageMessage,
  DoneRenderingPdfMessage,
  GrabbingDoneMessage,
  GrabbingStoppedMessage,
  PagesInBetweenMessage,
  PdfRotationMessage,
  StartEntirePageGrabMessage,
} from "../../../constants/pdf-messages";
import {
  GetCurrentPageCommand,
  GetPagesInBetweenCommand,
  SetPdfRotationCommand,
  StopGrabCommand,
} from "../../../constants/pdf-commands";
import { PDF_VIEWER_ADDRESS } from "@/api/config";
import PdfEntirePageExtraction from "./PdfEntirePageExtraction";
import { mapActions, mapGetters } from "vuex";
import { getFullPageExtractionRequestConfig } from "../../../api/config";
import { PdfsNavigation } from "@/store/modules/fsm/messages";
import router from "@/router/index";
import { h } from "vue";

export default {
  name: "pdf-doc",
  props: {
    pdf: null,
    id: null,
    selectedPdf: {
      type: Number,
      required: true,
    },
  },
  components: {
    "entire-page-extraction": PdfEntirePageExtraction,
  },
  data() {
    return {
      viewer: PDF_VIEWER_ADDRESS,
      iframe: Object,
      isChecked: false,
      showModal: false,
    };
  },
  computed: {
    pdfViewerFrame: function () {
      return this.$refs["pdfFrame"].contentWindow;
    },
    ...mapGetters("login/pdf", {
      pdfRotation: "getPdfRotation",
    }),
  },
  mounted() {
    EventBus.on("refreshMessage", (event) => {
      if (this.pdf !== null) this.refreshData(this.pdf);
    });

    EventBus.on(GrabbingDoneMessage, (event) => {
      if (event.data) {
        this.getExtraction(event);
      }
    });

    // if user changes PDF rotation, save it
    EventBus.on(PdfRotationMessage, (event) => {
      this.savePdfRotation(event.data.param.rotation);
    });

    // postMessage() is async, so need to wait for a response from the PDF end
    // otherwise the rotation value is set before PDF renders
    EventBus.on(DoneRenderingPdfMessage, () => {
      // FIXME: NO ROTATION FROM THIS.$ROUTE.PARAMS, THIS CAUSED VIEWR'S PDF TO HAVE A 'NAN' VALUE FOR ROTATION
      if (this.$route.params.rotation !== null) {
        this.pdfViewerFrame.postMessage(
          {
            message: SetPdfRotationCommand,
            rotation: this.pdfRotation,
          },
          window.location.origin
        );
      }
    });

    EventBus.on(StartEntirePageGrabMessage, () => {
      // prompt a dialog, asking which page(s) to extract
      this.promptEntirePageGrabModal();
    });

    EventBus.on(CurrentPageMessage, (e) => {
      // parse page information, including page number, width, and height, to grab full page(s)
      this.grabFullPage(e.data.param);
    });

    EventBus.on(PagesInBetweenMessage, (e) => {
      this.grabFullPages(e.data.param);
    });
  },
  beforeDestroy() {
    EventBus.off(GrabbingDoneMessage);
    EventBus.off(GrabbingStoppedMessage);
    EventBus.off("refreshMessage");
    EventBus.off(PdfRotationMessage);
    EventBus.off(DoneRenderingPdfMessage);
    EventBus.off(StartEntirePageGrabMessage);
    EventBus.off(CurrentPageMessage);
    EventBus.off(PagesInBetweenMessage);
    delete this.pdfViewerFrame;
    delete this.viewer;
    this.viewer = null;
    delete this.iframe;
    this.iframe = null;
    delete this.isChecked;
    this.isChecked = null;
    delete this.showModal;
    this.showModal = null;
  },
  methods: {
    ...mapActions("login/pdf", ["setRotation"]),

    refreshData(pdf) {
      if (pdf !== null) {
        // Every post to the viewer names this origin, never '*': the frame
        // holds a chart's PDF, and a viewer that had been navigated elsewhere
        // must not receive it. The viewer accepts only this origin back
        // (public/pdf/js/ipdf.js), and event-bus.js only its replies.
        this.pdfViewerFrame.postMessage({ pdf: pdf }, window.location.origin);
        // reset. in case if user clicks crop and then picks another PDF
        this.pdfViewerFrame.postMessage({ message: StopGrabCommand }, window.location.origin);

        // if a new PDF renders, reset its rotation
        this.setRotation({ rotation: 0 });
      }
    },

    getExtraction(event) {
      let loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, `Extracting...`),
        }
      );

      const requestParams = {
        pdfId: this.id,
        source: event.data.param,
        destination: {
          height: event.data.param.selections[0].selection.height,
          width: event.data.param.selections[0].selection.width,
        },
      };

      console.log(JSON.stringify(requestParams));

      getGrabbedImage(requestParams)
        .then((response) => {
          // ask PdfExtraction to add to the extracted list
          EventBus.emit("addToExtractedList", { response, requestParams });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
          loader = null;
        });

      this.pdfViewerFrame.postMessage({ message: StopGrabCommand }, window.location.origin);
    },

    grabFullPage(requestedPageParams) {
      let loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, `Extracting...`),
        }
      );
      console.log(JSON.stringify(requestedPageParams));
      const requestParams = getFullPageExtractionRequestConfig(
        this.id,
        requestedPageParams.pageNumber,
        requestedPageParams.width,
        requestedPageParams.height,
        requestedPageParams.rotation
      );

      console.log(JSON.stringify(requestParams));

      getGrabbedImage(requestParams)
        .then((response) => {
          // ask PdfExtraction to add to the extracted list
          EventBus.emit("addToExtractedList", { response, requestParams });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
          loader = null;
        });
    },

    grabFullPages(requestedPagesParams) {
      console.log(requestedPagesParams);

      for (let i = 0; i < requestedPagesParams.length; i++) {
        this.grabFullPage(requestedPagesParams[i]);
      }
    },

    /* if user selects another pdf, remove current extractions */
    clearUserInteraction() {
      EventBus.emit("clearUserInteraction");
    },

    // TODO validate inputs
    extractCurrentPage(pageNumber) {
      // ask PDF end for current page info
      this.pdfViewerFrame.postMessage(
        { message: GetCurrentPageCommand, pageNumber: pageNumber },
        window.location.origin
      );
    },

    extractPages(fromPage, toPage) {
      this.pdfViewerFrame.postMessage(
        { message: GetPagesInBetweenCommand, fromPage: fromPage, toPage: toPage },
        window.location.origin
      );
    },

    savePdfRotation(rotation) {
      this.setRotation({ rotation: rotation });
    },

    promptEntirePageGrabModal() {
      this.showModal = true;
    },
  },
  watch: {
    pdf(newPdf) {
      this.refreshData(newPdf);
      this.clearUserInteraction();
    },
  },
};
</script>
<style scoped lang="scss">
.pdf-doc {
  width: 100%;
}

.iframe {
  width: 100% !important;
  height: 70vh;
  background-color: #fff;
  border: 1px solid lighten(#000, 70%);
}

.switch {
  margin-left: 0.5rem;
}

.btn-toolbar {
  background-image: url("../../../assets/images/texture.png"),
    linear-gradient(hsla(0, 0%, 32%, 0.99), hsla(0, 0%, 27%, 0.95));
  box-shadow: inset 1px 0 0 hsla(0, 0%, 100%, 0.08), inset 0 1px 1px hsla(0, 0%, 0%, 0.15),
    inset 0 -1px 0 hsla(0, 0%, 100%, 0.05), 0 1px 0 hsla(0, 0%, 0%, 0.15),
    0 1px 1px hsla(0, 0%, 0%, 0.1);

  .btn {
    color: #ffffff;
    border-right: 1px solid darken(#fff, 60%);

    &:hover {
      border: 1px solid lighten(#000, 20%);
      background-color: lighten(#000, 20%);
      color: #ffffff;
    }
  }

  .icon {
    color: #fff;
  }
}
.selected {
  background-color: lighten(#000, 20%);
}
</style>
